import {
  Box, Grid,
} from '@material-ui/core';
import * as React from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import type { AxiosError } from 'axios';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import RefineResults from './RefineResults';
import RepairResults from './RepairResults';
import type { IRefineResultsProps, IRepairResult } from './RepairLookupInterfaces';
import RepairLookupCtx from './RepairLookupContext';

const useStyles = makeStyles(() => createStyles({
  root: {
    flexGrow: 1,
  },
}));

const RepairLookup: React.FC = () => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  const [resultSet, setResultSet] = React.useState <Array<IRepairResult> | null>(null);
  const [loading, setLoading] = React.useState<boolean>(false);

  const emptyFilterSet = {
    repairType: { repairTypeName: '', repairTypeValue: 0 },
    repairBarcode: '',
    storeRepairNumber: '',
    company: { companyId: '', companyName: '' },
    store: { storeId: '', storeName: '' },
    location: '',
    startDate: new Date(),
    endDate: new Date(),
  };

  const [filterSet, setFilterSet] = React.useState<IRefineResultsProps>(emptyFilterSet);

  const handleEmptyFilterSet = () => {
    setFilterSet(emptyFilterSet);
  };

  const handleRefineResults = (filterSetParam: IRefineResultsProps) => {
    setLoading(true);
    axios.post<Array<IRepairResult>>('/repairlookup/repairlookup', filterSetParam)
      .then((response) => {
        setResultSet(response.data);
        setLoading(false);
      })
      .catch((error: AxiosError) => {
        enqueueSnackbar(error?.response?.data, { persist: false, variant: 'error' });
        setLoading(false);
      });
  };

  return (
    <RepairLookupCtx.Provider value={{ filterSet, setFilterSet }}>
      <Box className={classes.root}>
        <Grid container spacing={2}>
          <Grid item xs={1} />
          <Grid item xs={9} container spacing={3}>
            <Grid item xs={12}>
              <RefineResults
                handleRefineResults={handleRefineResults}
                handleEmptyFilterSet={handleEmptyFilterSet}
                loading={loading}
              />
            </Grid>
            <Grid item xs={12}>
              {resultSet
                && (
                  <RepairResults
                    loading={loading}
                    resultSet={resultSet}
                  />
                )}
            </Grid>
          </Grid>
          <Grid item xs={2} />
        </Grid>
      </Box>
    </RepairLookupCtx.Provider>
  );
};
export default RepairLookup;
